<template>
  <div>
    <el-tabs v-show="!isShowRecords" v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane
        v-for="item in tabOptions"
        :key="item.name"
        :label="item.label"
        :name="item.name"
      >
        <component
          v-if="activeName === item.name"
          :is="item.component"
          @showRecords="showRecords"
        ></component>
      </el-tab-pane>
    </el-tabs>
    <!-- <Records
      v-if="isShowRecords"
      :custom-type="customType"
      @goBack="isShowRecords = false"
    ></Records> -->
  </div>
</template>

<script>
import allocated from './components/allocated.vue';
import deleteRecord from './components/deleteRecord.vue';
import waitForDistribution from './components/waitForDistribution.vue';
// import Records from './components/records.vue';
export default {
  name: 'ExternalContactManagement',
  components: {
    allocated,
    deleteRecord,
    waitForDistribution,
    // Records,
  },
  data() {
    return {
      activeName: 'allocated',
      tabOptions: [
        {
          name: 'allocated',
          label: '已分配客户',
          component: allocated,
        },
        {
          name: 'waitForDistribution',
          label: '待分配客户',
          component: waitForDistribution,
        },
        {
          name: 'deleteRecord',
          label: '删除客户记录',
          component: deleteRecord,
        },
      ],
      customType: 0,
      isShowRecords: false,
      breadcrumb: [
        {
          menu_name: '企业微信管理',
        },
        {
          menu_name: '外部联系人管理',
          // menu_path: 'externalContactManagement',
        },
        {
          menu_name: '已分配客户',
        },
      ],
    };
  },
  created() {
    if (this.$route.query.tab) {
      this.activeName = this.$route.query.tab;
    }
    this.breadcrumbChange();
  },
  methods: {
    handleTabClick(tab) {
      const { name } = tab;
      this.activeName = name;
      this.breadcrumbChange();
    },
    breadcrumbChange() {
      this.breadcrumb[2] = {
        menu_name: this.tabOptions.find((tab) => tab.name === this.activeName).label,
      };
      this.breadcrumb.reverse().reverse();
      this.g_breadcrumb(this.breadcrumb);
    },
    // 查看分配记录
    showRecords(params) {
      this.customType = params.custom_type;
      this.g_tourl(
        `/saas/externalContactManagement/records.html?customType=${this.customType}&tab=${this.activeName}`,
        {},
      );
      // this.isShowRecords = true;
    },
  },
};
</script>
